import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBook = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.47949 6.8877C7.47949 6.33542 7.92721 5.8877 8.47949 5.8877H16.4795C17.0318 5.8877 17.4795 6.33542 17.4795 6.8877V8.8877C17.4795 9.43998 17.0318 9.8877 16.4795 9.8877H8.47949C7.92721 9.8877 7.47949 9.43998 7.47949 8.8877V6.8877ZM8.97949 8.3877H15.9795V7.3877H8.97949V8.3877ZM4.47949 5.3877C4.47949 4.00699 5.59878 2.8877 6.97949 2.8877H18.4795C19.8602 2.8877 20.9795 4.00699 20.9795 5.3877V19.6377C20.9795 20.0519 20.6437 20.3877 20.2295 20.3877H5.97949C5.97949 20.94 6.42721 21.3877 6.97949 21.3877H20.2295C20.6437 21.3877 20.9795 21.7235 20.9795 22.1377C20.9795 22.5519 20.6437 22.8877 20.2295 22.8877H6.97949C5.59878 22.8877 4.47949 21.7684 4.47949 20.3877V5.3877ZM5.97949 18.8877H19.4795V5.3877C19.4795 4.83542 19.0318 4.3877 18.4795 4.3877H6.97949C6.42721 4.3877 5.97949 4.83542 5.97949 5.3877V18.8877Z",
		fill: "currentColor"
	})
});
export default SvgBook;
